import React from "react";
import Request from "../../Request";
import {chooseLocationFields} from "../../settings";
import _ from "lodash";
import ReactTooltip from "react-tooltip";
import {debounce} from 'throttle-debounce';
import {connect} from "react-redux";
import {NotificationManager} from "react-notifications";
import "../../less/stylesheet/form-input.css";
import '../../containers/Home/style.css'
import '../../less/locationPicker.css'

import {Helmet} from "react-helmet";

const $ = window.$;

const addressTypeList = [
    {name: "Home", value: "home", icon: "fa fa-home"},
    {name: "Office", value: "office", icon: "fa fa-building"},
    {name: "Hotel", value: "hotel", icon: "fa fa-hotel"},
]

class LocationPicker extends React.Component {
    events = {
        checkPostCode: async (text) => {
            let {selectedAddressLabel} = this.state;
            this.setState({selectedAddressLabel: text ? text.toUpperCase() : ""}, async () => {
                const isLoggedIn = localStorage.getItem('token') ? true : false
                if (text.length >= 5) {
                    let resp = await Request.checkValidPinCode({text})
                    if (resp == 'err') {
                        this.setState({errorMessage: 'Invalid Postcode', locationArray: []})
                    } else {
                        this.setState({errorMessage: ""}, () => {
                            this._findLocation(this.state.selectedAddressLabel);
                        })

                    }
                } else {
                    this.setState({
                        singleSlot: {},
                        showSearchBox: false,
                        pickupViewTime: '',
                        deliveryViewTime: '',
                        timeDefaultObj: '',
                        visibleTimerBlock: false,
                        locationArray: [],
                        selectedAddress: {},
                        selectedAddressOption: ""
                    })
                }
            })


        }
    }

    constructor(props) {
        super(props)
        this.state = {
            showSearchBox: false,
            locationArray: [],
            selectedAddress: {},
            selectedAddressLabel: '',
            visibleTimerBlock: false,
            pickupViewTime: '',
            deliveryViewTime: '',
            timeDefaultObj: {},
            singleSlot: {},
            selectedBlock: 0,
            hashTag: window.location.search,
            isDisabled: false,
            errorMessage: "",
            addressType: "",
            address: "",
            addressDetail: "",
            selectedAddressOption: ""
        }
        this.debouncedSearch = debounce(200, false, this._findLocation);

    }

    getAddressOptionValue = (item) => {
        return item ? JSON.stringify(item) : ""
    }

    findSelectedAddressOption = (locationArray = [], selectedAddress = {}) => {
        if (!locationArray || !locationArray.length || !selectedAddress) {
            return ""
        }
        let selectedItem = _.find(locationArray, (item) => {
            return (selectedAddress.Id && item.Id == selectedAddress.Id)
                || (selectedAddress.Label && item.Text && selectedAddress.Label.indexOf(item.Text) >= 0)
        })
        return selectedItem ? this.getAddressOptionValue(selectedItem) : ""
    }

    hydrateAddressState = () => {
        let {selectedAddress, singleSlot, addressType, addressDetail} = this.props;
        if (selectedAddress && selectedAddress.viewAddress) {
            let selectedAddressLabel = selectedAddress.PostalCode ? selectedAddress.PostalCode : '';
            let clonedAddress = _.cloneDeep(selectedAddress);
            if (clonedAddress.Label) {
                clonedAddress.Label = clonedAddress.Label.replace(/[\r\n]+/gm, " ")
            }
            this.setState({
                selectedAddress: clonedAddress,
                selectedAddressLabel,
                singleSlot: singleSlot ? singleSlot : {},
                addressType: addressType ? addressType : "",
                addressDetail: addressDetail ? addressDetail : "",
                selectedAddressOption: this.findSelectedAddressOption(this.state.locationArray, clonedAddress)
            })
            if (!this.state.locationArray.length && selectedAddressLabel) {
                this._restoreAddressOptions(selectedAddressLabel)
            }
        }
    }
    addEvents = {
        chooseType: (addressType) => {
            this.setState({addressType})
        },
        updateState: (data) => {
            this.setState({...data})
        }
    }

    _restoreAddressOptions(query) {
        if (!query) {
            return
        }
        Request.getGeoJsonByText({text: query}).then((resp) => {
            if (resp && resp.data && resp.data.Items) {
                if (resp.data.Items.length >= 1) {
                    if (resp.data.Items[0].Type == 'Address') {
                        this.setState({
                            locationArray: resp.data.Items,
                            selectedAddressOption: this.findSelectedAddressOption(resp.data.Items, this.state.selectedAddress)
                        })
                    } else {
                        this._choosePostCode(resp.data.Items[0]);
                    }
                } else {
                    this.setState({locationArray: [], selectedAddressOption: ""})
                }
            } else {
                this.setState({locationArray: [], selectedAddressOption: ""})
            }
        })
    }

    componentDidMount() {
        $(document).ready(function () {
            var some_id = $('#searchBox');
            some_id.prop('type', 'text');
            some_id.removeAttr('autocomplete');
        });
        this.hydrateAddressState()
    }

    componentWillMount() {
        if (!(this.props.selectedAddress && this.props.selectedAddress.viewAddress)) {
            this._setAddressIfLogin()
        }
    }

    async _getSingleSlot(postalCode) {
        this.props.showLoader()
        const isLoggedIn = localStorage.getItem('token') ? true : false
        let resp = await Request.getSlotByPostalCode({postalCode: postalCode ? postalCode : ''});
        this.setState({
            singleSlot: resp,
            showSearchBox: false,
            pickupViewTime: '',
            deliveryViewTime: '',
            timeDefaultObj: '',
            visibleTimerBlock: isLoggedIn ? false : resp ? true : false
        })
        this.props.hideLoader()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedAddress !== this.props.selectedAddress
            || prevProps.singleSlot !== this.props.singleSlot
            || prevProps.addressType !== this.props.addressType
            || prevProps.addressDetail !== this.props.addressDetail) {
            this.hydrateAddressState()
        }
    }

    _findLocation(query) {
        let selectedAddress = {}
        if (query) {
            Request.getGeoJsonByText({text: query}).then((resp) => {
                if (resp && resp.data && resp.data.Items) {
                    if (resp.data.Items.length >= 1) {
                        if (resp.data.Items[0].Type == 'Address') {
                            this.setState({locationArray: resp.data.Items, selectedAddress, selectedAddressOption: ""})
                        } else {
                            this._choosePostCode(resp.data.Items[0]);
                        }
                    } else {
                        this.setState({locationArray: resp.data.Items, selectedAddress, selectedAddressOption: ""})
                    }
                } else {
                    this.setState({locationArray: [], selectedAddress, selectedAddressOption: ""})
                }
            })
        } else {
            this.setState({locationArray: [], selectedAddress, selectedAddressOption: ""})
        }

    }

    _choosePostCode(query) {
        Request.getGeoJsonByPostCode({text: query.Text, id: query.Id}).then((resp) => {
            console.log(resp);
            if (resp && resp.data && resp.data.Items) {
                let items = []
                this.setState({
                    locationArray: resp.data.Items,
                    showSearchBox: true,
                    selectedAddressOption: this.findSelectedAddressOption(resp.data.Items, this.state.selectedAddress)
                })

            }
        })
    }

    async _setAddressIfLogin() {
        let selectedAddress = ''
        let selectedAddressLabel = ''
        const loginUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
        if (loginUser && loginUser._id) {
            this.props.showLoader()
            let {data} = await Request.getUser(loginUser);
            if (data && data._id && data.address && data.address.PostalCode) {
                selectedAddress = data.address;
                _.each(chooseLocationFields, (item) => {
                    if (selectedAddress[item] && !selectedAddressLabel) {
                        selectedAddressLabel = selectedAddress[item];
                        if (selectedAddress['Street']) {
                            selectedAddress['Street'] = selectedAddress.Label;
                        }
                        selectedAddress['viewAddress'] = selectedAddressLabel;
                    }
                })
                selectedAddress.Label = selectedAddress.Label.replace(/[\r\n]+/gm, " ")
                this.setState({showSearchBox: false, selectedAddress, selectedAddressLabel, isDisabled: true}, () => {
                    this._getSingleSlot(selectedAddress.PostalCode);
                })
            } else {
                this.props.hideLoader()
            }
        }
    }


    _hideTimer = () => {
        this.setState({visibleTimerBlock: false})
    }

    _chooseAddress(query) {
        if (query) {
            query = JSON.parse(query)
        }
        let selectedAddress = {}
        let selectedAddressLabel = ''
        Request.getGeoJsonAddressFullInfo({text: query.Text, id: query.Id}).then((resp) => {
            if (resp.data && resp.data.Items && resp.data.Items.length) {
                selectedAddress = resp.data.Items[0];
                if (selectedAddress && selectedAddress.PostalCode) {
                    this._getSingleSlot(selectedAddress.PostalCode);
                }
                _.each(chooseLocationFields, (item) => {
                    if (selectedAddress[item] && !selectedAddressLabel) {
                        selectedAddressLabel = selectedAddress[item];
                        selectedAddress['viewAddress'] = selectedAddressLabel;
                    }
                })
                if (selectedAddress.Label) {
                    selectedAddress.Label = selectedAddress.Label.replace(/[\r\n]+/gm, " ")
                }
            }

            this.setState({
                showSearchBox: false,
                selectedAddress,
                visibleTimerBlock: false,
                selectedAddressOption: query ? this.getAddressOptionValue(query) : ""
            })
        })
    }

    _placeOrder = async () => {
        let {selectedAddress, addressType, addressDetail, singleSlot} = this.state;
        this._hideTimer();
        if (!selectedAddress || (selectedAddress && !selectedAddress.viewAddress)) {
            return NotificationManager.warning('Please Choose Address');
        }
        if (addressType) {
            if (addressType == "hotel" && !addressDetail) {
                return NotificationManager.warning('Your room number');
            } else if (addressType == "office") {
                // return NotificationManager.warning('Add office address details');
            } else {
                // return NotificationManager.warning('Add address details (apartment name, number, floor ...)');
            }
        }


        let data = {
            slotId: singleSlot._id,
            address: selectedAddress,
            singleSlot,
            addressType,
            addressDetail
        }
        this.props._placeOrderCallback(data)
    }

    render() {

        let {
            locationArray, showSearchBox, selectedAddressLabel, selectedAddress,
            timeDefaultObj, isDisabled, errorMessage, addressType, addressDetail, selectedAddressOption
        } = this.state;
        let inputClasses = `search-query form-control ${selectedAddress && selectedAddress.viewAddress ? 'addressSelected' : ''}`

        const getPlaceholder = () => {
            if (addressType == "hotel") {
                return "Your room number"
            } else if (addressType == "office") {
                return "Add office address details"
            } else {
                return "Add address details (apartment name, number, floor ...)"
            }
        }

        return (
            <React.Fragment>
                <Helmet>
                    <link rel="preload" href="/assets/fonts/truck.woff?akwne7" as="font" type="font/woff" crossOrigin/>
                    <link rel="preload" href="/assets/css/fontCss.css" as="style" onLoad="this.rel='stylesheet'"/>
                </Helmet>
                <form className="banner-form" id={'mainForm'} autocomplete="off">
                    <div className="row">
                        {selectedAddress && selectedAddress.viewAddress && !showSearchBox ?
                            <ReactTooltip id='addressToolTip' type='success'>
                                <span>{selectedAddress.Label}</span>
                            </ReactTooltip> : ''}
                        <div className="col-md-12">
                            <p className="text-row">Enter your postcode</p>
                            <div className="related-form">
                                <a data-tip data-for='addressToolTip'>
                                    {isDisabled ?
                                        <div className={`${inputClasses} mb-3`}
                                             id={'searchBox'}>{selectedAddressLabel}</div>
                                        :
                                        <div className={'newSearchInputDiv'}>
                                            <input className={inputClasses}
                                                   id={'searchBox'}
                                                   style={{marginBottom: 0}}
                                                   autoComplete="off"
                                                   value={selectedAddressLabel}
                                                   onChange={(e) => this.events.checkPostCode(e.target.value)}
                                                   placeholder="Enter your postcode"
                                                   type="text"/>
                                            {errorMessage ? <div className={'error'}>{errorMessage}</div> : ""}
                                        </div>}
                                </a>


                            </div>
                        </div>
                    </div>
                    {locationArray && locationArray.length ?
                        <div className={'row'}>
                            <div className="col-md-12 col-sm-12 related-form  mb-2">
                                <select className={'form-control'}
                                        value={selectedAddressOption}
                                        onChange={(e) => this._chooseAddress(e.target.value)}
                                        placeholder="Enter your postcode & select an address">
                                    <option value={""}>Please select your address</option>
                                    {locationArray.map((item, key) => {
                                        return (
                                            <option value={this.getAddressOptionValue(item)}
                                                    key={key}>{item.Text} {item.Description}</option>
                                        )
                                    })}

                                </select>
                            </div>
                        </div> : null}

                    {selectedAddress && selectedAddress.viewAddress ?
                        <div className={'order_address_box'}>
                            <div className={'address_btn_group'}>
                                {addressTypeList.map((item) => {
                                    return (
                                        <a className={`${item.value == addressType ? "active" : ""}`} key={item.value}
                                           onClick={() => {
                                               this.addEvents.chooseType(item.value)
                                           }}><i className={item.icon}/> {item.name}</a>
                                    )
                                })}
                            </div>
                            <div className={'address_form'}>
                                <input placeholder={getPlaceholder()}
                                       value={addressDetail}
                                       onChange={({target}) => {
                                           this.addEvents.updateState({addressDetail: target.value})
                                       }}
                                       className={'form-control'}/>
                            </div>
                        </div> : null}


                    <div className="place-order">
                        <button className="btn btn-my" type="button" id={"schedulePickUp"}
                                onClick={() => this._placeOrder(timeDefaultObj)}>
                            Next &nbsp;<img src="/assets/img/arrow-right.png"/>
                        </button>
                    </div>
                </form>
            </React.Fragment>
        )
    }
}


const mapStateToProps = ({global, router}) => {

}
const mapDispatchToProps = (dispatch) => {
    return {
        showLoader: () => dispatch({type: 'SHOW_LOADER'}),
        hideLoader: () => dispatch({type: 'HIDE_LOADER'}),
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LocationPicker)
